<template>
  <div
    class="accordions-group"
    :aria-label="`Listar ${items.length} objekt`"
  >
    <accordion-block
      v-for="(item, index) in itemsList"
      :key="index"
      :tracking-scope="trackingScope"
      v-bind="item"
      :has-border="hasBorder"
      :size="size"
    >
      <template #content>
        <!-- Content needs to be wrapped as an array to get into correct parser -->
        <wysiwyg :content="[item.content]" />
      </template>
    </accordion-block>

    <show-more
      v-if="(limit && showLimit) && (limit < items.length)"
      button-text="Visa alla"
      @showMoreResult="showLimit = 0"
    />
  </div>
</template>

<script>
import showMore from '@/vue/components/common/showMore'
import "#/Controls/Plus"

export default {
  name: "IcaAccordionGroup",
  components: {
    showMore
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    // If show more should be used, this sets where the break will be. If 0, no show more will be used and all items are visible from start.
    limit: {
      type: Number,
      default: 5
    },
    trackingScope: {
      type: String,
      default: ""
    },
    hasBorder: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 80
    }
  },
  data () {
    return {
      showLimit: 0
    }
  },
  computed: {
    itemsList () {
      if (this.showLimit !== 0 && this.items.length > this.showLimit) {
        return this.items.slice(0, this.showLimit)
      } else {
        return this.items
      }
    }
  },
  mounted () {
    this.showLimit = this.limit
  }
}
</script>
